import type { ReactStoryblokComponent } from "modules/storyblok/types";
import RichtextAdapter from "../RichtextAdapter";
import legalContentStyles from "./LegalContent.styles";
import type { ContentAdapterProps } from "../Content";

const LegalContentAdapter = ({ blok: { content } }: ReactStoryblokComponent<ContentAdapterProps>) => (
  <RichtextAdapter content={content} customStyles={legalContentStyles} />
);

export default LegalContentAdapter;
